import React from 'react';
import { isEmpty } from 'lodash/fp';
import SearchInput from './SearchInput';
import InviteesTable from './InviteesTable';

const InviteesList = ({ count, invitees, onRemove, onAdd }) => (
  <div className="mt-48">
    <h2 className="ff-ss">
      {t('in_person_training.invite_users.who_to_invite')}
    </h2>
    <SearchInput invitees={invitees} onSuggestionSelected={onAdd} />
    {!isEmpty(invitees) && (
      <InviteesTable invitees={invitees} onRemove={onRemove} />
    )}
  </div>
);

export default InviteesList;
